<template>
  <v-dialog v-model="gettersError" persistent max-width="900">
    <v-card class="card-error-500">
      <v-card-title class="card-title-icon">
        <v-icon>fas fa-exclamation-circle</v-icon>
      </v-card-title>
      <v-card-text class="card-text">
        <h1 class="red--text">Erro Interno do Servidor</h1>
        <p class="mb-0">
          Ocorreu o erro <strong class="red--text">{{ error }}</strong
          >. Contate o administrador do sistema.
        </p>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="card-actions">
        <v-btn @click="close" color="error">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from '@/store';

export default {
  data: () => ({
    show: false
  }),

  computed: {
    gettersError() {
      return store.getters['errors/getError500'].active;
    }
  },

  props: {
    error: { type: String, default: undefined },
    status: { type: Number, default: null }
  },

  methods: {
    close() {
      this.$store.dispatch('errors/closeError500');
    }
  }
};
</script>

<style lang="scss" scoped>
.card-error-500 {
  .card-title-icon {
    display: flex;
    justify-content: center;
    padding: 20px 10px 0;
    .v-icon {
      color: var(--v-error-base);
      font-size: 5rem;
    }
  }

  .card-text {
    text-align: center;
    span {
      display: block;
      margin-bottom: 20px;
    }
  }

  .card-detail {
    position: relative;
    &:before {
      bottom: 100%;
      left: 50%;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-width: 8px;
      transform: translateX(-50%);
    }

    .v-card__text {
      font-weight: 300;
      max-height: 200px;
      overflow-y: scroll;
    }
  }
  .card-actions {
    display: flex;
    justify-content: center;
  }
}

.theme--dark {
  .card-error-500 {
    .card-detail {
      background-color: #444;
      &:before {
        border-bottom-color: #444;
      }
    }
  }
}

.theme--light {
  .card-error-500 {
    .card-detail {
      background-color: rgb(222, 222, 222);
      &:before {
        border-bottom-color: rgb(222, 222, 222);
      }
    }
  }
}
</style>
